import React, { useState, useEffect, useCallback, useRef } from "react";
import { withRouter } from 'react-router-dom';
import {
  SemanticContainer,
  SemanticSegment,
  SemanticTable
} from './styled';
import { Segment, Divider } from 'semantic-ui-react';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import Loading from "../../../../components/Loading"
import swal from "sweetalert";
import { isAuthAdmin } from "../../../../services/auth";

import { producaov2 as api } from "../../../../services/apis";

const LogsVoittoCoin = props => {
  const id = props.match.params.id;
  const [aluno, setAluno] = useState({});
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    loadAuth();
    loadVoittoCoin();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();
    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };


  const loadVoittoCoin = async () => {
    await api
      .get(`logVoittoCoin/add/alunos/${id}`)
      .then(res => {
        const array = res.data;
        if (array.logs_voittocoins !== null && array.logs_voittocoins !== undefined) {
          const newJson = JSON.parse(array.logs_voittocoins.json);
          newJson.sort(ordemDecrescente);
          array.logs_voittocoins.json = newJson;
        } else {
          array.logs_voittocoins = { json: [] };
        }
        setAluno(array);
        setLoading(false);
      }).catch(err => {
        console.error(err)
        swal("Não foi possível carregar os logs", "", "error");
        setLoading(false);
      })
  };

  const ordemDecrescente = (a, b) => {
    return a.data < b.data;
  }
  return (
    <>

      <AdminMenu />
      {loading ? <Loading /> : (
        <SemanticContainer>
          <h2>Logs voittocoins do usuario {aluno.nome} ({aluno.id})</h2>
          <Divider />
          <Segment>
            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell style={{ width: "15%" }}>ID CURSO </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "25%" }}>CAMINHO </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "15%" }}>VALOR INSERIDO </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "15%" }}>VALOR FINAL </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell style={{ width: "30%" }}>DATA</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {aluno.logs_voittocoins.json.map((log, index) => (
                  <SemanticTable.Row>
                    <SemanticTable.Cell>{log.id_curso}</SemanticTable.Cell>
                    <SemanticTable.Cell>{log.caminho}</SemanticTable.Cell>
                    <SemanticTable.Cell>{log.value_insert}</SemanticTable.Cell>
                    <SemanticTable.Cell>{log.value_final}</SemanticTable.Cell>
                    <SemanticTable.Cell>{log.data}</SemanticTable.Cell>
                  </SemanticTable.Row>

                ))}

              </SemanticTable.Body>
            </SemanticTable>
          </Segment>
        </SemanticContainer>
      )}
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2021
        </SemanticSegment>
      </SemanticContainer>
    </>
  )
}

export default withRouter(LogsVoittoCoin);
